import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { store } from './app/store';
import { Provider } from 'react-redux';
import Config from './Config';

ReactDOM.render(
  <React.StrictMode>
    <Config>
      <Provider store={store}>
        <App />
      </Provider>
    </Config>
  </React.StrictMode>,
  document.getElementById('root'),
);
